import React from 'react';
import ReactDOM from 'react-dom/client';
import toast from 'react-hot-toast';
import App from './App';
import { registerSW, unregisterSW } from './pwa';

// Expose toast for SW update notifications
window.__jengoToast = toast;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// In development: unregister any lingering service workers immediately
// In production: register the SW
if (process.env.NODE_ENV === 'production') {
  registerSW();
} else {
  unregisterSW();
}
